import VueSelectionController from '@aspectus/vue-selection-controller'
import OrderView from './View'
import StateInfo from './StateInfo'

export function install(Vue) {
  Vue.component(OrderView.name, OrderView)
  Vue.component(StateInfo.name, StateInfo)
  Vue.use(VueSelectionController, {
    name: 'v-selection-controller',
  })
}

export default { install }
